import { forwardRef, type Ref, type SVGProps } from 'react';
import { SvgIcon } from '../../components/icon/icon';

interface SVGRProps {
  title?: string;
  titleId?: string;
}
const DragDots = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    ref={ref}
    aria-labelledby={titleId}
    {...props}>
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fill="currentColor"
      d="M7.5 6c0-.21 0-.314.012-.4A1.275 1.275 0 0 1 8.6 4.512c.085-.012.19-.012.4-.012s.313 0 .4.012A1.275 1.275 0 0 1 10.488 5.6c.012.085.012.19.012.4s0 .314-.012.4A1.275 1.275 0 0 1 9.4 7.489c-.085.012-.19.012-.4.012s-.313 0-.4-.012A1.275 1.275 0 0 1 7.512 6.4C7.5 6.316 7.5 6.21 7.5 6m0 6c0-.21 0-.313.012-.4A1.275 1.275 0 0 1 8.6 10.512c.085-.012.19-.012.4-.012s.313 0 .4.012a1.275 1.275 0 0 1 1.088 1.088c.012.085.012.19.012.4s0 .313-.012.4A1.275 1.275 0 0 1 9.4 13.488c-.085.012-.19.012-.4.012s-.313 0-.4-.012A1.275 1.275 0 0 1 7.512 12.4c-.012-.085-.012-.19-.012-.4m0 6c0-.209 0-.314.012-.4a1.275 1.275 0 0 1 1.086-1.087c.088-.012.192-.012.4-.012s.316 0 .401.012a1.275 1.275 0 0 1 1.086 1.086c.012.087.012.192.012.401s0 .314-.012.4a1.276 1.276 0 0 1-1.086 1.087c-.087.012-.192.012-.4.012s-.314 0-.401-.012A1.275 1.275 0 0 1 7.512 18.4c-.012-.086-.012-.191-.012-.4m6-12c0-.21 0-.314.012-.4A1.275 1.275 0 0 1 14.6 4.512c.085-.012.19-.012.4-.012s.313 0 .4.012A1.275 1.275 0 0 1 16.489 5.6c.012.085.012.19.012.4s0 .314-.012.4A1.275 1.275 0 0 1 15.4 7.489c-.085.012-.19.012-.4.012s-.313 0-.4-.012A1.275 1.275 0 0 1 13.512 6.4c-.012-.085-.012-.19-.012-.4m0 6c0-.21 0-.313.012-.4a1.275 1.275 0 0 1 1.088-1.088c.085-.012.19-.012.4-.012s.313 0 .4.012a1.275 1.275 0 0 1 1.088 1.088c.012.085.012.19.012.4s0 .313-.012.4a1.275 1.275 0 0 1-1.088 1.088c-.085.012-.19.012-.4.012s-.313 0-.4-.012a1.275 1.275 0 0 1-1.088-1.088c-.012-.085-.012-.19-.012-.4m0 6c0-.209 0-.314.012-.4a1.276 1.276 0 0 1 1.086-1.087c.088-.012.192-.012.4-.012.21 0 .316 0 .401.012a1.276 1.276 0 0 1 1.086 1.086c.012.087.012.192.012.401s0 .314-.012.4a1.276 1.276 0 0 1-1.086 1.087c-.087.012-.192.012-.4.012s-.314 0-.401-.012a1.276 1.276 0 0 1-1.086-1.086c-.012-.087-.012-.192-.012-.401"
      vectorEffect="non-scaling-stroke"
    />
  </svg>
);
const ForwardRef = forwardRef(DragDots) as SvgIcon;
export { ForwardRef as ReactComponent };
